import { AuthService } from './../../base/services/auth.service';
import { Injectable } from "@angular/core";
import { SideNavigationService } from "src/app/base/side-navigation/side-navigation.service";
import { activationEmailTemplatesExpConfRoute, configurationsExpConfRoute, configurationTemplatesExpConfRoute, emailTemplatesExpConfRoute, fieldAssignmentTemplatesExpConfRoute, fieldValueReplacementsRoute, historyExpConfRoute } from "src/app/core/routing/route-names";

@Injectable()
export class ExportConfigurationRoutesService {

  constructor(
    private sideNavService: SideNavigationService,
    private authService: AuthService
  ) { }

  public initializeNavigationData(): void {
    this.sideNavService.navigationData = [
      {
        designation: 'i18n.domain.export-configuration.export-configuration-routes.configurations',
        route: configurationsExpConfRoute
      }
    ];

    if (this.authService.isUserAdmin()) {
      this.sideNavService.navigationData.push(...[
        {
          designation: 'i18n.domain.export-configuration.export-configuration-routes.fieldValueReplacements',
          route: fieldValueReplacementsRoute
        },
        {
          designation: 'i18n.domain.export-configuration.export-configuration-routes.configurationTemplates',
          route: configurationTemplatesExpConfRoute
        },
        {
          designation: 'i18n.domain.export-configuration.export-configuration-routes.fieldAssignmentTemplates',
          route: fieldAssignmentTemplatesExpConfRoute
        },
        {
          designation: 'i18n.domain.export-configuration.export-configuration-routes.emailTemplates',
          route: emailTemplatesExpConfRoute
        },
        {
          designation: 'i18n.domain.export-configuration.export-configuration-routes.activationEmailTemplates',
          route: activationEmailTemplatesExpConfRoute
        }
      ]);
    }

    this.sideNavService.navigationData.push({
      designation: 'i18n.domain.export-configuration.export-configuration-routes.history',
      route: historyExpConfRoute
    });
  }
}
